import { SxProps, Theme } from "@mui/material";

export const BookDetailContentStyle: SxProps<Theme> = () => {
  return {
    ".info": {
      fontWeight: 700,
      color: "#fff",
    },
  };
};
